import React, { ReactNode, useRef } from 'react';

import { AccordionDetails } from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import {
  AccordionTitle,
  AccordionCustom,
  AccordionSummaryHover,
} from '../../../../components/project-details-tabs/building-details/styles';

interface IAccordionExpansionDetails {
  title: string;
  children: ReactNode | null;
  defaultExpanded?: boolean;
}

const AccordionExpansion: React.FC<IAccordionExpansionDetails> = (
  props: IAccordionExpansionDetails
) => {
  const { title, children, defaultExpanded } = props;
  const myRef = useRef(null);

  return (
    <AccordionCustom
      ref={myRef}
      onChange={(e, expanded) => {
        if (expanded) {
          setTimeout(() => {
            window.scrollBy({ top: 50, behavior: 'smooth' });
          }, 100);
        }
      }}
      defaultExpanded={defaultExpanded}
    >
      <AccordionSummaryHover expandIcon={<ExpandMoreIcon />}>
        <AccordionTitle>{title}</AccordionTitle>
      </AccordionSummaryHover>
      <AccordionDetails>{children}</AccordionDetails>
    </AccordionCustom>
  );
};

AccordionExpansion.defaultProps = {
  defaultExpanded: false,
};

export default AccordionExpansion;
